import { environment } from "src/variables";
// Components
import React, { useEffect } from "react";
import Form from "src/app/components/Form";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
// Styles
import { Wrapper, Spacer } from "src/app/App.styles";
import { ThemeProvider, createStyles, createTheme, makeStyles, Theme } from "@material-ui/core";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const theme = createTheme({
  palette: {
    primary: {
      main: "#D13E3A",
    },
    secondary: {
      main: "#44599e",
    },
    text: {
      primary: "#201d1e",
    },
  },
});

const formFields: any = {
  name: { label: "Full name / Business name", type: "text", required: true },
  phone: {
    label: "Phone number",
    type: "tel",
    required: true,
    minLength: 10,
    maxLength: 10,
  },
  email: { label: "Email", type: "text", required: false },
  message: {
    label: "Message",
    type: "text-field",
    required: false,
    maxLength: 250,
  },
  agree: {
    disclaimer:
      "By checking this box, you agree to receive text messages from Mohave Service related to sending.<br/> " +
      "You may reply STOP to opt-out at any time. Reply HELP for assistance. Message and data rates may apply. Messaging frequency may vary.<br/>" +
      "Learn more on our <a href='/privacy' class='react-link'>Privacy Policy</a> Page, " +
      "<a href='/terms' class='react-link'>Terms of Service</a> Page, and <br/>" +
      "<a href='/well-terms' class='react-link'>Well Terms of Service</a> Page.",
    label: "Yes, I agree to receive text messages from Mohave Service sent from (435) 691-4901",
    type: "checkbox",
  },
};

const getCookie = () => (document.cookie ? document.cookie : null);

export const setCookie = (name: any) => {
  const optSelected = getCookie();
  document.cookie = optSelected
    ? `name=${name}; Secure; SameSite=Strict; Path=/`
    : `name=temp_opt; Secure; SameSite=Strict; Path=/`;
};

export default function OptIn() {
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      background: {
        backgroundSize: "cover",
        backgroundPosition: "center",
      },
      foreground: {
        minWidth: "100%",
        minHeight: "100%",
      },
      form: {
        color: "#ffffff",
      },
    })
  );

  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = (name: string) => {
    setCookie(name);
    setOpen(false);
  };

  useEffect(() => {
    const optSelected: any = getCookie();
    if (!optSelected) handleOpen();
    if (optSelected && optSelected.includes("name=temp_opt")) handleOpen();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <Button autoFocus color="inherit" onClick={() => handleClose("min_cookie_opt")}>
              Accept essential cookies
            </Button>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div"></Typography>
            <Button autoFocus color="inherit" onClick={() => handleClose("all_cookie_opt")}>
              Accept all
            </Button>
          </Toolbar>
        </AppBar>
        <Spacer height={32} />
        <Wrapper>
          <Typography sx={{ ml: 2, flex: 1 }} component="p">
            We use cookies to improve your experience on our site. By using our site, you consent to the use of cookies.
            Rejecting cookies will prevent non-essential cookies from loading.
          </Typography>
        </Wrapper>
        <Spacer height={32} />
        <div className={classes.background}>
          <section className={classes.foreground}>
            <Form className={classes.form} formFields={formFields} urlRequest="/public/contact_email" />
          </section>
        </div>
      </Dialog>
    </ThemeProvider>
  );
}
